var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenubars(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 12 12",
    enableBackground: "new 0 0 12 12",
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    height: 1,
    width: 11,
    x: 0.5,
    y: 5.5
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    height: 1,
    width: 11,
    x: 0.5,
    y: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    height: 1,
    width: 11,
    x: 0.5,
    y: 8.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenubars);
export default __webpack_public_path__ + "static/media/menubars.3448366482e3c3e187d6e00168805d97.svg";
export { ForwardRef as ReactComponent };